export default __webpack_public_path__ + "static/media/07_photo.da9dbd7d.jpg";